import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements OnInit, OnChanges {
    @Input() settings: IModalSettings
    @Input() user: ILocationUser
    @Output() change = new EventEmitter();
    updateCommand = false
    ngOnChanges(changes: SimpleChanges) {
        this.updateCommand = false;
        this.change.emit(false);
    }
    constructor() { }

    performAction() {
        switch (this.settings.type) {
            case 5:
                break;
        }
    }
    save() {
        this.change.emit(true);
        this.updateCommand = true;
    }
    ngOnInit() {

    }

}
